// extracted by mini-css-extract-plugin
export default {"buttonGroup":"ButtonGroup_buttonGroup__VLJfp","spin":"ButtonGroup_spin__8o3+4"};